import { queryClient } from '../queryClient';

export function invalidateRecommendations() {
  queryClient.invalidateQueries({ queryKey: ['RECOMMENDATIONS'] });
}
